import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Am a React passionate, loving a lot what am doing which consists a major part of our life. I believe in hard work and every day of mine contains a part where am thinking what are the possibilities to make this beautiful world a better place for living. `}</p>
    </blockquote>
    <p>{`Besides, I love reading, cooking, cycling and travelling. This is mainly what describes me and a lot more fun includes my work, create awesome applications, trying to solve a problem in any sense.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      